module.exports = __webpack_public_path__ + "img/JD.a4c94008.png";